import React from 'react';
import PropTypes from "prop-types";
import { EuiCodeBlock } from '../../../../../src/components/code';
import { EuiSpacer } from '../../../../../src/components/spacer';
export var GuideSectionSnippets = ({
  snippets
}) => {
  let snippetCode;

  if (typeof snippets === 'string') {
    snippetCode = <EuiCodeBlock language="jsx" fontSize="m" paddingSize="m" isCopyable>
        {snippets}
      </EuiCodeBlock>;
  } else {
    snippetCode = snippets.map((snip, index) => <React.Fragment key={`snippet${index}`}>
        <EuiCodeBlock language="jsx" fontSize="m" paddingSize="m" isCopyable>
          {snip}
        </EuiCodeBlock>
        {index < snippets.length - 1 && <EuiSpacer size="xs" />}
      </React.Fragment>);
  }

  return <React.Fragment>{snippetCode}</React.Fragment>;
};
GuideSectionSnippets.propTypes = {
  snippets: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.string.isRequired).isRequired]).isRequired
};

try {
  GuideSectionSnippets.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/components/guide_section/guide_section_parts/guide_section_snippets.tsx',
    description: '',
    displayName: 'GuideSectionSnippets',
    methods: [],
    props: {
      snippets: {
        defaultValue: null,
        description: '',
        name: 'snippets',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/components/guide_section/guide_section_parts/guide_section_snippets.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string | string[]'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}